import HttpFactory from '../factory'

class CitiesModule extends HttpFactory<any[]> {
  async searchByName(key = '') {
    return await this.call<any>('GET', `?nom=${key}&limit=20`)
  }
  async searchByLocalityCode(code: any) {
    return await this.call<any>('GET', `/${code}`)
  }
}

export default CitiesModule
